import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
export function NewFinalClose() {
  return <Section className="bg-forest-mist py-24" data-id="element-129">
      <div className="max-w-3xl mx-auto text-center" data-id="element-130">
        <div className="mb-10" data-id="element-131">
          <p className="text-xl md:text-2xl text-forest-deep/90 font-medium mb-2 italic" data-id="element-132">
            No necesitás esta guía cuando todo está bien.
          </p>
          <p className="text-xl md:text-2xl text-forest-deep font-bold" data-id="element-133">
            La necesitás antes de que vuelva a pasar.
          </p>
        </div>

        <Button variant="primary" size="xl" href={CHECKOUT_URLS.superPack} className="bg-forest-deep hover:bg-forest text-white font-bold w-full sm:w-auto px-8 py-5 text-base sm:text-lg" data-id="element-134">
          👉 QUIERO TENERLO ANTES DE NECESITARLO
        </Button>
      </div>
    </Section>;
}